import { FC } from 'react'
import { Box, useTheme } from '@mui/material'
import { Modal } from 'components/Modal'
import { ItemDetails } from 'components'
import { useTranslation } from 'react-i18next'

export interface ResetConfrimationProps {
    open?: any
    onClose?: any
    onReset?: any
    onCancel?: any
}

export const ResetConfrimation: FC<ResetConfrimationProps> = (props) => {
    const { open, onClose, onReset, onCancel } = props
    const { t } = useTranslation()
    const theme = useTheme()
    const footerContent = (
        <Box
            display="flex"
            width="100%"
            justifyContent="space-between"
            padding="24px 32px"
        >
            <Box minWidth="88px">
                <ItemDetails.ActionButton
                    fontColor="#ffffff"
                    bgColor={theme?.palette?.primary?.main}
                    width="100%"
                    onClick={onReset}
                >
                    {t('YesResetMyMasterPassword')}
                </ItemDetails.ActionButton>
            </Box>

            <Box minWidth="130px">
                <ItemDetails.ActionButton
                    fontColor="#ffffff"
                    bgColor={'#aab0b4'}
                    width="100%"
                    onClick={onCancel}
                >
                    {t('Cancel')}
                </ItemDetails.ActionButton>
            </Box>
        </Box>
    )

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={t('ResetMasterPasswordConfirmation')}
            footerContent={footerContent}
        >
            <Box>
                Warning! Are you sure you have forgotten your master password?
                All of your saved passwords will be deleted if you proceed.
            </Box>
        </Modal>
    )
}
